import { render, staticRenderFns } from "./TrafficMasterData.vue?vue&type=template&id=0b9b9cf6&scoped=true"
import script from "./TrafficMasterData.vue?vue&type=script&lang=js"
export * from "./TrafficMasterData.vue?vue&type=script&lang=js"
import style0 from "./TrafficMasterData.vue?vue&type=style&index=0&id=0b9b9cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9b9cf6",
  null
  
)

export default component.exports